






















import { sortBy } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { Auth } from 'aws-amplify'

import { $db } from '@/services/Db'

import EditableTable from '@/components/EditableTable.vue'
import ProductForm from './ProductForm.vue'
import Downloader from '@/components/Downloader.vue'

@Component({ components: { EditableTable, ProductForm, Downloader } })
export default class ProductsPage extends Vue {

	req = { loading: true, errors: [] }
	products: any[] = []
	sub: { unsubscribe: () => void } | null = null

	columns = ['id', 'friendly', 'sku']

	editing = null
	newSymbol = Symbol('New Product')

	created() {
		this.req.loading = true
		const { data, subscription } = $db.subscribe('products', 'Product', 'id friendly sku', this, 'products')
		this.sub = subscription
		data.then(items => this.products = items)
			.catch(err => this.req.errors = Array.isArray(err.errors) ? err.errors.map(e => e.message) : [err.message])
			.finally(() => this.req.loading = false)
	}

	destroyed() {
		if(this.sub) {
			this.sub.unsubscribe()
		}
	}

}
